export const symbols = {
    GBP: '£',
    EUR: '€',
    USD: '$',
    CAD: '$',
    AUD: '$',
    CHF: '', // Swiss francs don't have a currency symbol
    MXN: '$',
    NOK: 'kr',
    SEK: 'kr',
    DKK: 'kr.',
} as const;
